import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ComponentBase } from '../../../classes/base/component-base';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/primeng';
import { FileType } from '../../../../dapfood/common/constant';
var FileViewerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FileViewerComponent, _super);
    function FileViewerComponent(ref, config) {
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.config = config;
        _this.scale = 100;
        _this.top = 0;
        _this.left = 0;
        _this.dragging = false;
        _this.rotation = 0;
        _this.lastMouseX = 0;
        _this.lastMouseY = 0;
        _this.offsetX = 0;
        _this.offsetY = 0;
        _this.isPopupVisible = false;
        _this.popupPosition = { x: 0, y: 0 };
        _this.selectedIndex = 0;
        _this.isShowDestroyConfirm = false;
        _this.fileType = FileType;
        _this.listFile = [];
        _this.isShowRejectReason = false;
        _this.rejectReason = '';
        _this.emitDataImage = new EventEmitter();
        return _this;
    }
    FileViewerComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    //window.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
                    return [4 /*yield*/, this.showPopup(this.config.data.file, this.config.data.listFile || [], this.config.data.optionBrowse, this.config.data.obj)];
                    case 1:
                        //window.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // ngOnDestroy(): void {
    //     window.removeEventListener('wheel', this.onWheel.bind(this));
    // }
    // Sử dụng với file list idFile
    FileViewerComponent.prototype.showPopup = function (item, data, optionBrowse, obj) {
        if (data === void 0) { data = []; }
        if (optionBrowse === void 0) { optionBrowse = -1; }
        if (obj === void 0) { obj = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.listFile = data.filter(function (x) { return x.type == FileType.Image || x.type == FileType.Video; }); // Chỉ view file image và video
                if (this.listFile && this.listFile.length > 0) {
                    this.listFile.forEach(function (item) {
                        item.type = FileType.Image; // Mặc định là kiểu ảnh
                        item.link = _this.getImageOriginal(item.id); // mặc định là theo kiểu ảnh
                        if (item.type == FileType.Video) {
                            item.type = FileType.Video;
                            item.link = "" + environment.apiDomain.fileEndpoint + _this.file.path;
                        }
                    });
                    // Nếu không truyền vào ảnh hiển thị mặc định thì lấy ảnh đầu tiên trong listFile
                    if (item == null) {
                        this.file = this.listFile[0];
                    }
                }
                if (item) {
                    this.file = item;
                    this.file.link = this.getImageOriginal(this.file.id); // mặc định là theo kiểu ảnh
                    this.file.type = this.file.type ? this.file.type : FileType.Image; // Mặc định là kiểu ảnh
                }
                return [2 /*return*/];
            });
        });
    };
    // // Sử dụng với List Object File
    // showPopupObject(file: any, data: any[] = []) {
    //     if (data.length > 0) {
    //         this.listFile = data.filter(x => x.type == 1);  // Chỉ view file image và video
    //     }
    //     this.file = file;
    //     if (this.file.type == 3)
    //         this.file.url = `${environment.apiDomain.fileEndpoint}${this.file.path}`;
    //     else
    //         this.file.url = this.getImageOriginal(this.file.id);
    //     this.idPharmacy = file.idPharmacy;
    // }
    // Duyệt ảnh trưng bày, viếng thăm
    FileViewerComponent.prototype.onAccepted = function (item, e) {
        var obj = {
            id: item.id,
            isAccepted: e.checked
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    };
    FileViewerComponent.prototype.onAcceptedDisplay = function (item, checked) {
        var obj = {
            id: item.id,
            isAccepted: true
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    };
    FileViewerComponent.prototype.onDestroyeddDisplay = function (item, checked) {
        var obj = {
            id: item.id,
            isAccepted: false,
            note: item.note
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    };
    FileViewerComponent.prototype.DestroyConfirmDisplay = function (check) {
        if (check === void 0) { check = false; }
        // this.showFileDialog = false;
        this.isShowRejectReason = true;
        this.rejectReason = '';
    };
    // end duyệt
    FileViewerComponent.prototype.getCurrent = function (item, index) {
        var currentIndex = this.listFile.indexOf(item);
        this.selectedIndex = currentIndex;
        this.file = this.listFile[currentIndex];
        // this.file.url = item.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.scale = 100;
        this.rotation = 0;
    };
    FileViewerComponent.prototype.onNext = function () {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0)
            return;
        var currentIndex = this.listFile.indexOf(this.file);
        var nextIndex = (currentIndex + 1) % this.listFile.length;
        this.file = this.listFile[nextIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = nextIndex;
    };
    FileViewerComponent.prototype.onPrev = function () {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0)
            return;
        var currentIndex = this.listFile.indexOf(this.file);
        var prevIndex = 0;
        if (currentIndex <= 0)
            prevIndex = this.listFile.length - 1;
        else
            prevIndex = currentIndex - 1;
        // prevIndex = (currentIndex - 1) % this.listFile.length;
        this.file = this.listFile[prevIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = prevIndex;
    };
    FileViewerComponent.prototype.onKeydownHandler = function (event) {
        // event.preventDefault();
        if (event.key === 'ArrowLeft') {
            //if (event.keyCode == 37) {
            this.onPrev();
        }
        if (event.key === 'ArrowRight') {
            this.onNext();
        }
    };
    FileViewerComponent.prototype.clickOutside = function (event) {
        this.isPopupVisible = false;
    };
    // urlFile(file) {
    //     if (file.path == null || file.path == undefined)
    //         return `/assets/images/no_image.jpg`; 
    //     return `https://docs.google.com/viewerng/viewer?url=https://wmapi.friends.vn/file.api//2023/9/23/mickey-tai-lieu-api_20230923115008708.docx`;
    // }
    // command menu
    FileViewerComponent.prototype.openPopup = function (event, item) {
        var posX = event.clientX;
        var posY = event.clientY;
        var popupWidth = 150;
        var popupHeight = 100;
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        if (posX + popupWidth > viewportWidth) {
            posX = viewportWidth - popupWidth;
        }
        if (posY + popupHeight > viewportHeight) {
            posY = viewportHeight - popupHeight;
        }
        this.popupPosition = { x: posX, y: posY };
        this.isPopupVisible = true;
    };
    // @HostListener('document:click')
    // closePopup() {
    //     this.isPopupVisible = false;
    // }
    FileViewerComponent.prototype.closePopup = function () {
        this.ref.close(null);
    };
    // zoom ảnh
    FileViewerComponent.prototype.onMouseDown = function (event, image) {
        if (event.button !== 0) {
            return;
        }
        this.dragging = true;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
        image.style.cursor = 'grabbing';
    };
    FileViewerComponent.prototype.onMouseMove = function (event) {
        if (!this.dragging)
            return;
        var deltaX = event.clientX - this.lastMouseX;
        var deltaY = event.clientY - this.lastMouseY;
        // this.left += deltaX;
        //this.top += deltaY;
        this.offsetX += deltaX;
        this.offsetY += deltaY;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
    };
    FileViewerComponent.prototype.onMouseUp = function () {
        this.dragging = false;
    };
    FileViewerComponent.prototype.onWheel = function (event) {
        var isInside = this.container.nativeElement.contains(event.target);
        if (isInside) {
            event.preventDefault();
            var newScale = this.scale - event.deltaY * 0.2;
            newScale = Math.max(newScale, 100);
            newScale = Math.min(newScale, 500);
            this.scale = newScale;
        }
    };
    FileViewerComponent.prototype.rotateImage = function (angle) {
        this.rotation = (this.rotation + angle) % 360; // Xoay ảnh, giữ giá trị trong khoảng 0-360
    };
    FileViewerComponent.prototype.handleEscape = function (event) {
        if (this.ref) {
            this.ref.close();
        }
    };
    return FileViewerComponent;
}(ComponentBase));
export { FileViewerComponent };
